export default __webpack_public_path__ + "static/media/Innenraum-des-hauses.b49c86c0.jpg";